module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/our_services_1-34ee3ab5dbe2c208665048dfe3c973f2.jpg";